
import { Vue, Component, Prop } from "vue-property-decorator";
import AppTableDesign from "@/components/base/table/AppTableDesign.vue";
import { ITableStatus } from "@/types";
import { Affiliate } from "@/services/affiliates/Affiliate";
import ItemTableList from "@/components/base/TableUI/ItemTableList.vue";
import { translateTwoFactor, translateUserStatus, translateUserType } from "@/utils/translate";
import { IUser } from "@/api/types/user";
import { ITableHeader } from "@/utils";
import router from "@/router";

function accountTypeFromUsersListRoute(): string {
    const q = router.currentRoute.query?.account_type;
    if (Array.isArray(q)) {
        return q[0] != null ? String(q[0]) : '';
    }
    return q != null && q !== '' ? String(q) : '';
}

@Component({
    components: { ItemTableList, AppTableDesign },
})
export default class UsersTable extends Vue {
    @Prop({ required: true }) items!: Affiliate[];
    @Prop({ default: 100 }) limit!: number;
    @Prop({ default: 0 }) total!: number;
    @Prop({ default: true }) loading!: boolean;
    @Prop({ default: false }) isDetailPage!: boolean;

    headers: ITableHeader[] = [
        { text: 'User ID', value: 'id', align: 'center', width: '120px', fixed: true },
        { text: 'Account ID', value: 'account_id', align: 'center', width: '120px', fixed: true },
        { text: 'Имя', value: 'first_name', fixed: true },
        { text: 'Фамилия', value: 'last_name', fixed: true },
        { text: 'Почта', value: 'email', fixed: true },
        { text: 'Отдел', value: 'department.name', fixed: true },
        { text: '2fa', value: 'two_factor_enabled', align: 'center', fixed: true },
        { text: 'Статус', value: 'status', align: 'center', fixed: true },
    ];

    routes = [
        {
            routeParam: 'id',
            slot: 'item.id',
            extraRouteParamName: this.isEmployee ? 'id' : 'account_id',
            routerName: 'user-detail-page',
            text: 'id',
            template: (item: IUser & { user_id: number }): number | undefined => this.isEmployee ? item.user_id : item.id,
            getQuery: (item: { user_id: number, id: number, account_type?: string }): { id: number, account_type: string } => ({
                id: this.isEmployee ? item.user_id : item.id,
                account_type: item.account_type ?? accountTypeFromUsersListRoute(),
            }),
        },
        {
            routeParam: 'id',
            extraRouteParamName: this.isEmployee ? 'id' : 'account_id',
            slot: 'item.account_id',
            routerName: 'user-detail-page',
            text: 'account_id',
            template: (item: IUser): number | undefined => this.isEmployee ? item.id : item.account_id,
            getQuery: (item: { user_id: number, id: number, account_type?: string }): { id: number, account_type: string } => ({
                id: this.isEmployee ? item.user_id : item.id,
                account_type: item.account_type ?? accountTypeFromUsersListRoute(),
            }),
        },
    ];

    statuses: ITableStatus[] = [
        {
            slot: 'item.status',
            key: 'status',
            translate: translateUserStatus,
        },
        {
            slot: 'item.two_factor_enabled',
            key: 'two_factor_enabled',
            translate: translateTwoFactor,
        },
    ];

    uniqueData = [
        {
            slot: 'item.account_type',
            template: (item: IUser): string => translateUserType(item.account_type).text,
        },
    ];

    get isEmployee(): boolean {
        const accType = router.currentRoute.query?.account_type;
        const s = Array.isArray(accType) ? accType[0] : accType;
        return typeof s === 'string' && s.includes('employee');
    }

    get getHeaders(): ITableHeader[] {
        if (this.isEmployee) {
            return this.headers;
        }

        return this.headers.filter(h => h.value !== 'department.name');
    }

    submitData(offset: number, limit: number): void {
        this.$emit('update-table', offset, limit);
    }
}
